// Front.js
import React, { useState, useMemo, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  ListSubheader,
  TextField,
  InputAdornment
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from 'axios';
 import CustomButton from "../Reusable/CustomButton";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { SelectNormal, SelectSearch, MultipleSelect ,SelectNormalS} from '../Reusable/SelectBox'
import { BASE_URL } from "../../App";


const containsText = (text, searchText) =>
  text && String(text).toLowerCase().indexOf(searchText.toLowerCase()) > -1;

export default function Test() {
  const [dealer, setDealer] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const navigate = useNavigate();
  const login_id = localStorage.getItem('LOGIN_ID'); 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/getdealercode',
          {
            login_id: login_id 
          },
          {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('Token'),
            },
          }
        );
        setDealer(response.data.DEALER_CODE); 
        setFilteredOptions( 
          response.data.DEALER_CODE.map((dealerItem) => ({
            value: {
              DEALER_CODE: String(dealerItem.DEALER_CODE),
              DEALERNAME: String(dealerItem.DEALERNAME),
            },
          }))
        );
      } catch (error) {
        console.error('Error fetching dealer code:', error);
      }
    };
    fetchData();
  }, []);
  
  const handleDealerSearch = (searchValue) => {
    setSearchText(searchValue);
  
    const filtered = allOptions.filter((option) =>
      containsText(`${option.value.DEALER_CODE} - ${option.value.DEALERNAME}`, searchValue)
    );
  
    setFilteredOptions(filtered);
  };

  const handleButtonClick = (event) => {
    event.preventDefault();

    const selectedDealerCode = selectedOption && selectedOption.value && selectedOption.value.DEALER_CODE;
    console.log('Selected Dealer Code:', selectedDealerCode);
    localStorage.setItem('USER_ID', selectedDealerCode);
    //navigate(`/real?id=${selectedDealerCode}`)

    navigate(`/Home/Dealer/Real_Time_Info`);

  };

  const allOptions = useMemo(() => {
    return dealer.map((dealerItem) => ({
      value: {
        DEALER_CODE: String(dealerItem.DEALER_CODE),
        DEALERNAME: String(dealerItem.DEALERNAME),
      },
    }));
  }, [dealer]);

  return (
    <>
      
      <Box m={3}>
        <FormControl style={{ width: '500px' }}>
          <InputLabel id="search-select-label">Select Dealer</InputLabel>
          <Select
            MenuProps={{
              PaperProps: {
                sx: {
                  '& .MuiMenuItem-root': {
                    fontSize: '13px', 
                  },
                },
              },
            }}


            sx={{
              height: '50px', 
              '.MuiInputBase-root': {
                minHeight: '50px', 
              },
            }}



            labelId="search-select-label"
            id="search-select"
            value={selectedOption}
            label="Select Dealer"
            onChange={(e) => setSelectedOption(e.target.value)}
            onClose={() => setSearchText("")}
            renderValue={() => selectedOption ? `${selectedOption.value.DEALER_CODE} - ${selectedOption.value.DEALERNAME}` : ''}
            required={true}
          >
            <ListSubheader>
              <TextField
                size="small"
                autoFocus
                placeholder="Type to search..."
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
                onChange={(e) => handleDealerSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    e.stopPropagation();
                  }
                }}
              />
            </ListSubheader>
            {filteredOptions.map((option, i) => (
              <MenuItem key={i} value={option}>
                {`${option.value.DEALER_CODE} - ${option.value.DEALERNAME}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box m={3}>
        <ThemeProvider theme={createTheme()}>
          <CssBaseline />
          <CustomButton
            label="Submit"
            onClick={handleButtonClick}
            variant="contained"
            fullWidth
            height={40}
            width="23%"
            borderRadius="8px"
            sx={{ marginLeft: '60px' }}
            disabled={!selectedOption}
          />
        </ThemeProvider>
      </Box>
    </>
  );
}